import { useState } from "react";
import Button from "../../shared/Button";
import PasswordInput from "../../shared/PasswordInput";
import { useError } from "../../context/ErrorProvider";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { resetNewPassword } from "../../sdk/auth/auth";

const SetNewPassword = () => {
  const [errors, setErrors] = useState({});
  const { showError } = useError();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const resetIdentifier = localStorage.getItem("resetIdentifier")
    ? localStorage.getItem("resetIdentifier")
    : "";

  const validate = () => {
    const newErrors = {};
    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (!/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(newPassword)) {
      newErrors.newPassword =
        "Password must include a letter, number, special character and be at least 8 characters.";
    }
    if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    return newErrors;
  };

  const { mutate, isLoading } = useMutation({
    mutationKey: ["reset-my-password"],
    mutationFn: () =>
      resetNewPassword(resetIdentifier, newPassword, confirmPassword),
    onSuccess: (data) => {
      if (data.status === 200 || data?.status === 201) {
        navigate("/");
      }
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const errorMessage = Object.values(validationErrors).join("\n");
      showError(errorMessage);
      return;
    }
    setErrors({});
    mutate();
  };
  return (
    <div className="h-full w-[80%] flex flex-col pb-[100px] justify-end">
      <p className="text-[#222222] font-semibold text-[24px]">
        Set New Password
      </p>
      <p className="text-[#5C5C5C] font-medium text-[13px]">
        Create a strong password for your account. Make sure it’s something
        unique that you haven’t used before.
      </p>
      <form className="w-full" onSubmit={handleSubmit}>
        <div className="flex flex-col my-[20px]">
          <label
            className="font-medium text-[13px] text-[#000000]"
            htmlFor="password"
          >
            New Password
          </label>
          <PasswordInput
            placeholder="Enter your password"
            name="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          {errors.newPassword ? (
            <p className="text-[#000000] text-[13px]">{errors.newPassword}</p>
          ) : (
            <p className="text-[#5C5C5C] text-[13px]">
              Password must contain a letter, a number, a special character, and
              be at least 8 characters long.
            </p>
          )}
        </div>
        <div className="flex flex-col my-[20px]">
          <label
            className="font-medium text-[13px] text-[#000000]"
            htmlFor="password"
          >
            Confirm Password
          </label>
          <PasswordInput
            placeholder="Enter your password"
            name="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {errors.confirmPassword && (
            <p className="text-[#000000] text-[13px]">
              {errors.confirmPassword}
            </p>
          )}
        </div>
        <div className="w-full mt-[50px]">
          <Button
            label="Update Password"
            disabled={isLoading}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
};

export default SetNewPassword;
